// extracted by mini-css-extract-plugin
module.exports = {"container":"CookieAgreement_container__3ZDl1","content":"CookieAgreement_content__2M20O","title":"CookieAgreement_title__2qAKz","btn":"CookieAgreement_btn__x840l"};